<template>
    <li :class="evaluateClassForItem"
        ref="iconElement"
        @click="action_SelectReservation()"
        @dblclick="action_DoubleClick"
        @mouseover="action_ReservationMouseOver()"
        @mouseout="action_ReservationMouseOut()"/>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import { closeAlertPopup } from '../../../../../sheet-alert'
import { closePopup } from '../../../../../sheet-overlays'
import { setSelectedReservation } from '../../../../../reservation-selection'
import { setSelectedDate } from '../../../../../sheet-axis'
import { handleRefresh } from '../../../../../sheet-refresh'
import { editGuardState, invokeGuard } from '../../popup-edit-guard'
const moment = require('@/util/MPMoment')

export default {
    props: {
        reservation: Object,
        selectedReservation: Object,
    },
    data() {
        return {
            editGuard: editGuardState,

            isShow: false,
            hoverEvent: {
                x: undefined,
                y: undefined
            }
        }
    },
    watch: {

    },
    computed: {
        isSelected: function(){
            if (this.reservation?._id == undefined || this.selectedReservation?._id == undefined) { return false }
            else if (this.reservation._id == this.selectedReservation._id) { return true }
            else { return false }
        },
        evaluateClassForItem: function() {
            let css = ''
            css += this.reservation.isCanceled ? 'red' : 'blue'
            css += this.isSelected ? ' selected' : ''
            return css
        },
    },
    methods: {
        action_SelectReservation() {
            this.$emit('action_SelectReservation', this.reservation)
        },
        async action_DoubleClick() {
            if (this.editGuard.isEditBasicInfo) {
                let result = await invokeGuard('AlertEditUserBasicInfo')
                if (result == false) { 
                    closeAlertPopup()
                    return 
                }
            }
            else if (this.editGuard.isUserNoteChanged) {
                await invokeGuard('AlertEditUserNote')
            }
            let date = moment(this.reservation.startedAt).startOf('days')
            setSelectedDate(date)
            setSelectedReservation(deepCopy(this.reservation))
            handleRefresh()
            closePopup()
        },
        action_ReservationMouseOver() {
            let rect = this.$refs.iconElement.getBoundingClientRect()
            let rightCoordinate = rect.left + rect.width

            this.hoverEvent.x = rightCoordinate
            this.isShow = !this.isShow 
            this.$emit('action_ReservationMouseOver', this.reservation, this.hoverEvent, this.isShow)
        },
        action_ReservationMouseOut() {
            this.isShow = !this.isShow
            this.$emit('action_ReservationMouseOver', undefined, {}, this.isShow)
        }
    }
}
</script>